<form [formGroup]="this.ratingForm" (ngSubmit)="this.setFeedback()">  
    
    @if(this.errorMsg !== ''){
        <marv-message type="error">{{this.errorMsg | translate}}</marv-message>
    }
    
    @if(this.successMsg !== ''){
        <marv-message type="success">{{this.successMsg | translate}}</marv-message>
    }
    
    <div id="rating_missions">
        <div class="field_rating">
            <div class="field_rating_label">            
                <ion-icon name="star"></ion-icon>           
                {{'RATE_MISSIONS' | translate}}
            </div>
            <div class="field_rating_value">
                <marv-rating [value]="this.ratingValue" [max]="this.ratingMax" size="big" (onSelectRating)="this.selectRating($event)"/>
            </div>
        </div>

        <div id="field_rating_comment" class="field_rating">
            <div class="field_rating_label">            
                <ion-icon name="warning-outline"></ion-icon>           
                {{'STORE_INCIDENT_?' | translate}}
                <marv-toggle formName="incidentDeclared" [noMargin]="true"/>
            </div>
            <div class="field_rating_value">
                <marv-select 
                    label="{{'COMMENT' | translate}}" 
                    icon="pencil-outline" 
                    formName="customerFeedbackComment" 
                    [disabled]="this.disabledComment()"
                    [items]="this.customerFeedbackComments" 
                    [noMargin]="true"
                ></marv-select>
            </div>
        </div>    
    </div>    
    <div id="field_rating_button">
        <marv-button type="submit" label="{{'VALIDATE' | translate}}" [isFetching]="this.isFetchingSave" icon="checkmark-outline" />
    </div>
</form>
